// extracted by mini-css-extract-plugin
export default {"root":"styles_root__l9oBG","headerRow":"styles_headerRow__SsKpo"};